import { Avatar } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import i18next from 'i18next';

import { Client } from '@commons/types/clients';
import { Button, Box } from '@mui/material';
import { AvatarBoxStyle, AvatarStyle } from '../styledComponents';

export const getColumns = ({
  handleClientConnection,
  isClientConnectionLoading
}: {
  handleClientConnection: (row: Client) => void;
  isClientConnectionLoading: boolean;
}): GridColDef<Client>[] => [
  {
    field: 'name',
    headerName: i18next.t('CLIENTS_LIST.NAME_COLUMN'),
    width: 250,
    filterable: true,
    renderCell: (params) => (
      <Box sx={AvatarBoxStyle}>
        <Avatar src={params.row.img} alt={params.value} sx={AvatarStyle} />
        {params.value}
      </Box>
    )
  },
  {
    field: 'status',
    headerName: i18next.t('CLIENTS_LIST.STATUS_COLUMN'),
    width: 150
  },
  {
    field: 'salesHistoryRetrievedAt',
    headerName: i18next.t('CLIENTS_LIST.SALES_HISTORY_COLUMN'),
    width: 180,
    valueGetter: (params) =>
      params.value
        ? i18next.t('CLIENTS_LIST.SALES_HISTORY_RETRIEVED')
        : i18next.t('CLIENTS_LIST.SALES_HISTORY_NOT_RETRIEVED')
  },
  {
    field: 'useCase',
    headerName: i18next.t('CLIENTS_LIST.USE_CASE_COLUMN'),
    width: 150
  },
  {
    field: 'actions',
    headerName: i18next.t('CLIENTS_LIST.ACTIONS_COLUMN'),
    width: 120,
    filterable: false,
    sortable: false,
    renderCell: ({ row }) => (
      <Button
        disabled={isClientConnectionLoading}
        variant="outlined"
        size="small"
        onClick={() => handleClientConnection(row)}
      >
        {i18next.t('GENERAL.LOGIN')}
      </Button>
    )
  }
];
